export const CLASS_OPTIONS = [
    'Barbarian', 'Bard', 'Cleric', 'Druid', 'Fighter', 'Monk', 'Paladin', 'Ranger', 'Rogue', 'Sorcerer', 'Warlock', 'Wizard'
];

export const BACKGROUND_OPTIONS = [
    'Acolyte', 'Artisan', 'Charlatan', 'Criminal', 'Entertainer', 'Farmer', 'Guard', 'Guide', 'Hermit', 'Merchant', 'Noble', 'Sage', 'Sailor', 'Scribe', 'Soldier', 'Wayfarer'
];

export const RACE_OPTIONS = [
    'Aasimar', 'Dragonborn', 'Dwarf', 'Elf', 'Gnome', 'Goliath', 'Halfling', 'Human', 'Orc', 'Tiefling'
];

export const LINEAGE_OPTIONS = {
    'Elf': ['High Elf', 'Wood Elf', 'Drow'],
    'Tiefling': ['Infernal Legacy', 'Abyssal', 'Chthonic'],
    'Gnome': ['Forest Gnome', 'Rock Gnome'],
    'Goliath': ['Cloud Giant', 'Fire Giant', 'Frost Giant', 'Hill Giant', 'Stone Giant', 'Storm Giant'],
    'Dragonborn': ['Black', 'Blue', 'Brass', 'Bronze', 'Copper', 'Gold', 'Green', 'Red', 'Silver', 'White']
};

export const FIGHTING_STYLE_OPTIONS = [
    'Archery',
    'Defense',
    'Dueling',
    'Great Weapon Fighting',
    'Protection',
    'Two-Weapon Fighting',
    'Blind Fighting',
    'Interception',
    'Superior Technique',
    'Thrown Weapon Fighting',
    'Unarmed Fighting',
    'Blessed Warrior',
    'Druidic Warrior'
];

export const METAMAGIC_OPTIONS = [
    'Careful Spell',
    'Distant Spell',
    'Empowered Spell',
    'Extended Spell',
    'Heightened Spell',
    'Quickened Spell',
    'Seeking Spell',
    'Subtle Spell',
    'Transmuted Spell',
    'Twinned Spell'
];

export const INVOCATION_OPTIONS = [
    'Agonizing Blast',
    'Armor of Shadows',
    'Ascendant Step',
    'Beast Speech',
    'Beguiling Influence',
    'Bewitching Whispers',
    'Book of Ancient Secrets',
    'Devil\'s Sight',
    'Dreadful Word',
    'Eldritch Mind',
    'Eldritch Sight',
    'Eldritch Smite',
    'Eldritch Spear',
    'Eyes of the Rune Keeper',
    'Fiendish Vigor',
    'Gaze of Two Minds',
    'Ghostly Gaze',
    'Gift of the Depths',
    'Gift of the Ever-Living Ones',
    'Grasp of Hadar',
    'Improved Pact Weapon',
    'Investment of the Chain Master',
    'Lance of Lethargy',
    'Lifedrinker',
    'Maddening Hex',
    'Mask of Many Faces',
    'Master of Myriad Forms',
    'Minions of Chaos',
    'Mire the Mind',
    'Misty Visions',
    'One with Shadows',
    'Otherworldly Leap',
    'Protection of the Talisman',
    'Rebuke of the Talisman',
    'Relentless Hex',
    'Repelling Blast',
    'Sculptor of Flesh',
    'Shroud of Shadow',
    'Sign of Ill Omen',
    'Thief of Five Fates',
    'Thirsting Blade',
    'Tomb of Levistus',
    'Trickster\'s Escape',
    'Undying Servitude',
    'Visions of Distant Realms',
    'Voice of the Chain Master',
    'Whispers of the Grave',
    'Witch Sight'
];

export const RACE_DATA = {
    'Aasimar': {
        speed: 30,
        darkvision: 60,
        resistances: ['Necrotic', 'Radiant'],
        traits: [
            { name: "Celestial Resistance", description: "Resistance to Necrotic and Radiant damage." },
            { name: "Darkvision", description: "60ft range." },
            { name: "Healing Hands", description: "Magic Action: Heal target for d4s equal to PB (1/LR)." },
            { name: "Light Bearer", description: "You know the Light cantrip." },
            { name: "Celestial Revelation", description: "Level 3: Transform (Bonus Action) for flight or damage." }
        ]
    },
    'Dragonborn': {
        speed: 30,
        darkvision: 60,
        traits: [
            { name: "Draconic Ancestry", description: "Choose a dragon type for Breath Weapon and Resistance.", interactive: 'lineage' },
            { name: "Breath Weapon", description: "Replace attack with 15ft Cone or 30ft Line (1d10+ scale). Save vs damage." },
            { name: "Damage Resistance", description: "Resistance to your ancestry's damage type." },
            { name: "Darkvision", description: "60ft range." },
            { name: "Draconic Flight", description: "Level 5: Spectral wings give Fly Speed (10 min, 1/LR)." }
        ]
    },
    'Dwarf': {
        speed: 30,
        darkvision: 120,
        resistances: ['Poison'],
        traits: [
            { name: "Darkvision", description: "120ft range." },
            { name: "Dwarven Resilience", description: "Resistance to Poison damage. Adv on Poisoned saves." },
            { name: "Dwarven Toughness", description: "+1 HP per level." },
            { name: "Stonecunning", description: "Bonus Action: Tremorsense 60ft on stone (10 min, PB/LR)." }
        ]
    },
    'Elf': {
        speed: 30, // Wood Elf gets 35
        darkvision: 60, // Drow gets 120
        traits: [
            { name: "Darkvision", description: "60ft range (120ft for Drow)." },
            { name: "Elven Lineage", description: "Choose Drow, High Elf, or Wood Elf for spells/speed.", interactive: 'lineage' },
            { name: "Fey Ancestry", description: "Advantage vs Charmed." },
            { name: "Keen Senses", description: "Proficiency in Insight, Perception, or Survival." },
            { name: "Trance", description: "4 hour Long Rest. Magic can't put you to sleep." }
        ]
    },
    'Gnome': {
        speed: 30,
        darkvision: 60,
        traits: [
            { name: "Darkvision", description: "60ft range." },
            { name: "Gnomish Cunning", description: "Advantage on INT, WIS, CHA saves." },
            { name: "Gnomish Lineage", description: "Choose Forest (Minor Illusion + Speak w/ Animals) or Rock (Mending + Presti/Device).", interactive: 'lineage' }
        ]
    },
    'Goliath': {
        speed: 35,
        traits: [
            { name: "Giant Ancestry", description: "Choose Cloud (Teleport), Fire (Fire Dmg), Frost (Cold/Slow), Hill (Topple), Stone (Reaction Reduce Dmg), Storm (Reaction Thunder).", interactive: 'lineage' },
            { name: "Large Form", description: "Level 5: Become Large size (Adv STR, +10 Speed). 10 min, 1/LR." },
            { name: "Powerful Build", description: "Adv to end Grappled. Count as Large for carrying." }
        ]
    },
    'Halfling': {
        speed: 30,
        traits: [
            { name: "Brave", description: "Advantage vs Frightened." },
            { name: "Halfling Nimbleness", description: "Move through space of larger creatures." },
            { name: "Luck", description: "Reroll natural 1s on d20 tests." },
            { name: "Naturally Stealthy", description: "Hide even when obscured only by larger creature." }
        ]
    },
    'Human': {
        speed: 30,
        traits: [
            { name: "Resourceful", description: "Gain Heroic Inspiration on Long Rest." },
            { name: "Skillful", description: "Proficiency in one skill of your choice.", interactive: 'skill', count: 1 },
            { name: "Versatile", description: "Gain an Origin Feat of your choice.", interactive: 'originFeat' }
        ]
    },
    'Orc': {
        speed: 30,
        darkvision: 120,
        traits: [
            { name: "Adrenaline Rush", description: "Bonus Action Dash + Temp HP (PB times/LR)." },
            { name: "Darkvision", description: "120ft range." },
            { name: "Relentless Endurance", description: "Drop to 1 HP instead of 0 (1/LR)." }
        ]
    },
    'Tiefling': {
        speed: 30,
        darkvision: 60,
        traits: [
            { name: "Darkvision", description: "60ft range." },
            { name: "Fiendish Legacy", description: "Choose Abyssal (Poison/Necro), Chthonic (Necro), or Infernal (Fire). Grants Resistance + Spells.", interactive: 'lineage' },
            { name: "Otherworldly Presence", description: "You know the Thaumaturgy cantrip." }
        ]
    }
};

export const BACKGROUND_DATA = {
    'Acolyte': { feat: 'Magic Initiate (Cleric)', skills: ['Insight', 'Religion'], tool: 'Calligrapher\'s Supplies', ability: ['Intelligence', 'Wisdom', 'Charisma'] },
    'Artisan': { feat: 'Crafter', skills: ['Investigation', 'Persuasion'], tool: 'Artisan\'s Tools', ability: ['Strength', 'Dexterity', 'Intelligence'] },
    'Charlatan': { feat: 'Skilled', skills: ['Deception', 'Sleight of Hand'], tool: 'Forgery Kit', ability: ['Dexterity', 'Constitution', 'Charisma'] },
    'Criminal': { feat: 'Alert', skills: ['Sleight of Hand', 'Stealth'], tool: 'Thieves\' Tools', ability: ['Dexterity', 'Constitution', 'Intelligence'] },
    'Entertainer': { feat: 'Musician', skills: ['Acrobatics', 'Performance'], tool: 'Musical Instrument', ability: ['Strength', 'Dexterity', 'Charisma'] },
    'Farmer': { feat: 'Tough', skills: ['Animal Handling', 'Nature'], tool: 'Carpenter\'s Tools', ability: ['Strength', 'Constitution', 'Wisdom'] },
    'Guard': { feat: 'Alert', skills: ['Athletics', 'Perception'], tool: 'Gaming Set', ability: ['Strength', 'Intelligence', 'Wisdom'] },
    'Guide': { feat: 'Magic Initiate (Druid)', skills: ['Stealth', 'Survival'], tool: 'Cartographer\'s Tools', ability: ['Dexterity', 'Constitution', 'Wisdom'] },
    'Hermit': { feat: 'Healer', skills: ['Medicine', 'Religion'], tool: 'Herbalism Kit', ability: ['Constitution', 'Wisdom', 'Charisma'] },
    'Merchant': { feat: 'Lucky', skills: ['Animal Handling', 'Persuasion'], tool: 'Navigator\'s Tools', ability: ['Constitution', 'Intelligence', 'Charisma'] },
    'Noble': { feat: 'Skilled', skills: ['History', 'Persuasion'], tool: 'Gaming Set', ability: ['Strength', 'Intelligence', 'Charisma'] },
    'Sage': { feat: 'Magic Initiate (Wizard)', skills: ['Arcana', 'History'], tool: 'Calligrapher\'s Supplies', ability: ['Constitution', 'Intelligence', 'Wisdom'] },
    'Sailor': { feat: 'Tavern Brawler', skills: ['Acrobatics', 'Perception'], tool: 'Navigator\'s Tools', ability: ['Strength', 'Dexterity', 'Wisdom'] },
    'Scribe': { feat: 'Skilled', skills: ['Investigation', 'Perception'], tool: 'Calligrapher\'s Supplies', ability: ['Dexterity', 'Intelligence', 'Wisdom'] },
    'Soldier': { feat: 'Savage Attacker', skills: ['Athletics', 'Intimidation'], tool: 'Gaming Set', ability: ['Strength', 'Dexterity', 'Constitution'] },
    'Wayfarer': { feat: 'Lucky', skills: ['Insight', 'Stealth'], tool: 'Thieves\' Tools', ability: ['Dexterity', 'Wisdom', 'Charisma'] }
};

export const INSTRUMENT_OPTIONS = [
    'Bagpipes', 'Drum', 'Dulcimer', 'Flute', 'Lute', 'Lyre', 'Horn', 'Pan Flute', 'Shawm', 'Viol'
];

export const TOOL_OPTIONS = [
    'Alchemist\'s Supplies', 'Brewer\'s Supplies', 'Calligrapher\'s Supplies', 'Carpenter\'s Tools', 'Cartographer\'s Tools', 'Cobbler\'s Tools', 'Cook\'s Utensils', 'Glassblower\'s Tools', 'Jeweler\'s Tools', 'Leatherworker\'s Tools', 'Mason\'s Tools', 'Painter\'s Supplies', 'Potter\'s Tools', 'Smith\'s Tools', 'Tinker\'s Tools', 'Weaver\'s Tools', 'Woodcarver\'s Tools',
    'Disguise Kit', 'Forgery Kit', 'Herbalism Kit', 'Navigator\'s Tools', 'Poisoner\'s Kit', 'Thieves\' Tools'
];

export const ALIGNMENT_OPTIONS = [
    'Lawful Good', 'Neutral Good', 'Chaotic Good', 'Lawful Neutral', 'True Neutral', 'Chaotic Neutral', 'Lawful Evil', 'Neutral Evil', 'Chaotic Evil'
];

export const SUBCLASSES_BY_CLASS = {
    Barbarian: ['Path of the Berserker', 'Path of the Wild Heart', 'Path of the World Tree', 'Path of the Zealot'],
    Bard: ['College of Dance', 'College of Glamour', 'College of Lore', 'College of Valor'],
    Cleric: ['Life Domain', 'Light Domain', 'Trickery Domain', 'War Domain'],
    Druid: ['Circle of the Land', 'Circle of the Moon', 'Circle of the Sea', 'Circle of the Stars'],
    Fighter: ['Battle Master', 'Champion', 'Eldritch Knight', 'Psi Warrior'],
    Monk: ['Warrior of Mercy', 'Warrior of Shadow', 'Warrior of the Elements', 'Warrior of the Open Hand'],
    Paladin: ['Oath of Devotion', 'Oath of Glory', 'Oath of the Ancients', 'Oath of Vengeance'],
    Ranger: ['Beast Master', 'Fey Wanderer', 'Gloom Stalker', 'Hunter'],
    Rogue: ['Arcane Trickster', 'Assassin', 'Soulknife', 'Thief'],
    Sorcerer: ['Aberrant Sorcery', 'Clockwork Sorcery', 'Draconic Sorcery', 'Wild Magic'],
    Warlock: ['Archfey Patron', 'Celestial Patron', 'Fiend Patron', 'Great Old One Patron'],
    Wizard: ['Abjurer', 'Diviner', 'Evoker', 'Illusionist']
};

export const SKILL_ABILITY_MAP = {
    acrobatics: 'dexterity',
    animalHandling: 'wisdom',
    arcana: 'intelligence',
    athletics: 'strength',
    deception: 'charisma',
    history: 'intelligence',
    insight: 'wisdom',
    intimidation: 'charisma',
    investigation: 'intelligence',
    medicine: 'wisdom',
    nature: 'intelligence',
    perception: 'wisdom',
    performance: 'charisma',
    persuasion: 'charisma',
    religion: 'intelligence',
    sleightOfHand: 'dexterity',
    stealth: 'dexterity',
    survival: 'wisdom',
};

export const SPELL_SLOTS = {
    FullCaster: {
        1: [2],
        2: [3],
        3: [4, 2],
        4: [4, 3],
        5: [4, 3, 2],
        6: [4, 3, 3],
        7: [4, 3, 3, 1],
        8: [4, 3, 3, 2],
        9: [4, 3, 3, 3, 1],
        10: [4, 3, 3, 3, 2],
        11: [4, 3, 3, 3, 2, 1],
        12: [4, 3, 3, 3, 2, 1],
        13: [4, 3, 3, 3, 2, 1, 1],
        14: [4, 3, 3, 3, 2, 1, 1],
        15: [4, 3, 3, 3, 2, 1, 1, 1],
        16: [4, 3, 3, 3, 2, 1, 1, 1],
        17: [4, 3, 3, 3, 2, 1, 1, 1, 1],
        18: [4, 3, 3, 3, 3, 1, 1, 1, 1],
        19: [4, 3, 3, 3, 3, 2, 1, 1, 1],
        20: [4, 3, 3, 3, 3, 2, 2, 1, 1],
    },
    HalfCaster: {
        1: [2],
        2: [2],
        3: [3],
        4: [3],
        5: [4, 2],
        // ... simplified
    }
};

export const CLASS_SAVING_THROWS = {
    Barbarian: ['strength', 'constitution'],
    Bard: ['dexterity', 'charisma'],
    Cleric: ['wisdom', 'charisma'],
    Druid: ['intelligence', 'wisdom'],
    Fighter: ['strength', 'constitution'],
    Monk: ['strength', 'dexterity'],
    Paladin: ['wisdom', 'charisma'],
    Ranger: ['strength', 'dexterity'],
    Rogue: ['dexterity', 'intelligence'],
    Sorcerer: ['constitution', 'charisma'],
    Warlock: ['wisdom', 'charisma'],
    Wizard: ['intelligence', 'wisdom'],
};
